export type ColorScheme = "light" | "dark" | "system"

export function resolveThemePreferences(
  savedTheme: string | null,
  savedScheme: string | null,
  defaults: { theme?: string; scheme?: ColorScheme } = {},
) {
  const defaultTheme = defaults.theme || "oc-2"
  const themeId = savedTheme === "oc-1" ? "oc-2" : savedTheme || defaultTheme
  const fallback = defaults.scheme ?? "system"
  const colorScheme: ColorScheme =
    savedScheme === "light" || savedScheme === "dark" || savedScheme === "system" ? savedScheme : fallback
  return { themeId, colorScheme }
}
